export const peakStyles = {
	header: {
		backgroundColor: '#4e684b',
	},
	sidebar: {
		backgroundColor: '#010101',
		color: 'white',
	},
	button: {
		backgroundColor: '#4e684b',
		color: '#FFFFFF',
		border: '1px solid #3b4e38',
		fontWeight: 600,
		':hover': {
			color: '#ffffff',
			backgroundColor: '#3b4e38',
			borderColor: '#3b4e38',
		},
	},
	text: {
		color: '#010101',
		buttonLoadingColor: '#FFFFFF',
	},
	title: {
		color: '#ffffff',
	},
	table: {
		headerBackgroundColor: '#4e684b',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Peak Parking Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/peak/peak-icon.svg',
			height: 35,
			width: 45,
		},
		large: {
			src: '/peak/peak-logo-white.svg',
			height: 75,
			width: 100,
		},
	},
	favicon: {
		src: '/peak/peak-icon.svg',
	},
	socials: {
		linkedIn: 'https://www.linkedin.com/company/peak-parking-lp',
	},
	siteUrl: 'https://peakparking.com/',
	orgName: 'Peak Parking',
};
